import { BestPracticeRoutePayload, NotificationTypes, VoyNotification, WeatherAlarmNotificationData } from "../services/types/vessel-notifications-services.types";
export abstract class VesselAlarmsModelBase extends EventTarget {
	abstract get alarms(): VoyNotification<NotificationTypes.Alarm>[];
	abstract get alarmsWithoutResponses(): VoyNotification<NotificationTypes.Alarm>[];
	abstract checkForMoreAlarms(): void;
	abstract stateReason(alarm: VoyNotification<NotificationTypes.Alarm> | undefined): void;
	abstract postAlarmsReasons(payload: {}, notificationid: string|number):  Promise<void>;
	abstract editAlarms(alarm: VoyNotification<NotificationTypes.Alarm> ): void
	abstract get alarmsOnEditOptions() : VoyNotification<NotificationTypes.Alarm>[];
	abstract openLog(): void;
	abstract createAndSubmitRouteNotification(payload: BestPracticeRoutePayload): void;
	abstract _fetchWeatherAlarms(type: NotificationTypes.HeavyWeather|NotificationTypes.ParametricRoll|NotificationTypes.HeavyRolling|NotificationTypes.HighAccelerationForce): Promise<WeatherAlarmNotificationData[]>;
	abstract getNotificationData(id: String | Number): Promise<WeatherAlarmNotificationData>;

}
let VesselAlarmsModel: VesselAlarmsModelBase | null = null;

function setVesselAlarmsModel(model: VesselAlarmsModelBase) {
	VesselAlarmsModel = model;
}
export enum AlarmEvents {
	AlarmsUpdated = "alarms-changed",
	CheckMoreAlarms = "check-more-alarms",
	AlarmsEdited = "alarm-edited"
}

export { VesselAlarmsModel, setVesselAlarmsModel };
